<template>
    <div class="addresses" v-if="internalValue">
        <div class="address" v-for="(item, index) in internalValue" v-if="item.deleted != 1">

            <div class="preview" v-if="!item.editable">
                <figure><img :src="getImage(item)" /></figure>
                <div class="content">
                    <span>{{ item.company }}</span>
                    <span>{{ item.firstname }} {{ item.lastname }}</span>
                    <span>{{ item.street }} {{ item.street_number }}</span>
                    <span>{{ item.street_complement }}</span>
                    <span>{{ item.postal_code }} {{ item.locality }}</span>
                    <span>{{ item.country.name }}</span>
                </div>
            </div>

            <div class="form" v-show="item.editable">

                <form-text placeholder="Company" v-model="item.company" name="company"></form-text>
                <form-text placeholder="Prénom" v-model="item.firstname" name="firstname"></form-text>
                <form-text placeholder="Nom" v-model="item.lastname" name="lastname"></form-text>
                <form-text placeholder="Adresse" v-model="item.street" name="street"></form-text>
                <form-text placeholder="Complément d'adresse" v-model="item.street_complement" name="street_complement"></form-text>
                <form-text placeholder="Code postal" v-model="item.postal_code" name="postal_code"></form-text>
                <form-text placeholder="Ville" v-model="item.locality" name="locality"></form-text>
                <form-select label="Pays" multiple="false" v-model="item.country" :default="item.country_id" :options="$store.state.countries"></form-select>

            </div>

            <button @click="deleteAddress(item)" class="bt-remove"><span class="icon icon-icon_close"></span></button>
            <button @click="editAddress(item)" class="bt-edit">
                <span class="icon icon-icon_pencil" v-if="!item.editable"></span>
                <span class="icon icon-icon_check-circle" v-if="item.editable"></span>
            </button>

        </div>
        <button @click="createAddress()"><span>Ajouter</span></button>

    </div>
</template>

<script>

    export default {
        name: 'Address',
        props: ['value'],
        data: function () {
            return {
                internalValue: []
            }
        },
        created: function() {
            this.internalValue = this.value;
            this.refreshAddresses()
        },
        methods: {
            getImage: function(item){
                var link = (item.street + ',' + item.postal_code + ' ' + item.locality).replace(' ', '+');
                return 'https://maps.googleapis.com/maps/api/staticmap?center=' + link + '&region='+ item.country_id +'&zoom=16&scale=2&markers=color:blue|size:mid|' + item.lat + ',' + item.lng + '&size=400x400&maptype=roadmap&key=AIzaSyBnnvGJkJXGshnvb6R4Kp2825DEX2PK0JQ';
            },
            createAddress: function () {
                this.internalValue.push({editable:true,country:{}})
                this.$emit('input', this.internalValue);
            },
            editAddress: function (item) {
                if( item.editable != true ){
                    item.editable = true
                }else{
                    item.editable = false
                }
                this.$forceUpdate()
            },
            deleteAddress: function (item) {
                var ask = confirm("Delete ? (will be delete on save)");
                if( ask ){
                    item.deleted = 1
                    this.$forceUpdate()
                    this.$emit('input', this.internalValue);
                }
            },
            refreshAddresses: function(){

                var countries = {}
                for (let item of this.$store.state.countries) {
                    countries[item.id] = item
                }

                if( this.internalValue ){
                    for (let address of this.internalValue) {
                        if( address.country_id ){
                            address.country = countries[address.country_id]
                        }else if( address.country ){
                            address.country_id = address.country.id
                        }
                    }
                }
            }
        },
        watch: {
            'value'(newVal, oldVal) {
                this.internalValue = newVal
                this.refreshAddresses()
            },
            'internalValue'(newVal, oldVal) {
                this.refreshAddresses()
                this.$emit('input', this.internalValue);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/Address.vue